
import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const interfaceConfig: InterfaceConfig = {
  name: "sfi",
  interest_rate: 30,
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyDAtCLTqWu3XTjTC6AT2ZysdXUtL33bAX4"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: ["Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_BeRV6uYmO",
      userPoolClientId: "208j2kkvh8r32d2a9qq926t33f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_Y0yNT5nH4",
      userPoolClientId: "78ctmcltm4h9r5g3lgie7fl65f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
};
